/* eslint-disable */
import type { Money } from "../../common/currency.pb";
import type { GroupParticipant, PrimaryAction } from "./group.pb";

export enum SliceStatus {
  SLICE_STATUS_UNSPECIFIED = "SLICE_STATUS_UNSPECIFIED",
  SLICE_STATUS_PENDING = "SLICE_STATUS_PENDING",
  SLICE_STATUS_PAID = "SLICE_STATUS_PAID",
  SLICE_STATUS_DECLINED = "SLICE_STATUS_DECLINED",
  SLICE_STATUS_CANCELED = "SLICE_STATUS_CANCELED",
}

export interface GroupExpense {
  note?: string;
  group_token?: string;
  requester_token?: string;
  is_completed?: boolean;
  action?: PrimaryAction;
  pending_amount?: Money;
  total_amount?: Money;
  slice?: ExpenseSlice[];
  created_at_millis?: number;
  paid_amount?: Money;
  expense_slices_paid_count?: number;
  expense_token?: string;
}

export interface ExpenseSlice {
  requester?: GroupParticipant;
  responder?: GroupParticipant;
  amount?: Money;
  status?: SliceStatus;
  slice_token?: string;
  /** (may not be needed depending on designs) */
  action?: PrimaryAction;
}
